'use client'

import React from 'react'
import clsx from 'clsx'
import { ERROR_MESSAGES } from '@/constants/messages'
import styles from '../styles.module.scss'

const { HEADING, DESCRIPTIONS } = ERROR_MESSAGES.PAGE.FORBIDDEN

export default function Error403() {
  return (
    <div className={clsx(styles.errorContent, styles.error403)}>
      <div className={styles.errorSection}>
        <h1 className={clsx(styles.errorCode, styles.warn)}>403</h1>
        <div className={styles.messageSection}>
          <h2 className={styles.errorHeading}>{HEADING}</h2>
          <p className={styles.errorDescription}>
            {DESCRIPTIONS.map((text, i) => (
              <React.Fragment key={i}>
                {i > 0 && <br />}
                {text}
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>
    </div>
  )
}
